import api from "../../../services/api";


// ================= GET ALL =================
export const getClients = () =>
  api.get("/clients");


// ================= GET BY ID =================
export const getClientById = (id) =>
  api.get(`/clients/${id}`);


// ================= CREATE =================
export const createClient = (data) =>
  api.post("/clients", data);


// ================= UPDATE =================
export const updateClient = (id, data) =>
  api.put(`/clients/${id}`, data);


// ================= DELETE =================
export const deleteClient = (id) =>
  api.delete(`/clients/${id}`);
